const currentUrl = new URL(window.location.href);
const pathOnly = currentUrl.pathname;

document.querySelector('.nav-lang-switcher').addEventListener('click', switchLanguages);

// Language switcher display
if (pathOnly.includes('/ar/')) {
	document.querySelector('#lang-swicher_svg__lang-ar').style.opacity = 0.5;
} else {
	document.querySelector('#lang-swicher_svg__lang-en').style.opacity = 0.5;
}

function switchLanguages() {
	// console.log("will switch languages");
	if (pathOnly.includes('/ar/')) {
		window.location.href = currentUrl.href.replace("ar/", "");
	} else {
		window.location.href = currentUrl.origin + "/ar" + currentUrl.pathname;
	}
}

// Menu timeline
let menuOpened = false;
const tl = gsap.timeline({
	repeate: 1,
	ease: "power3.in",
	paused: true
});
tl.to('.wp-block-deltablocks-site-menu', {position: 'fixed'}, "start");
tl.to('#menu-button_svg__menu-button-line1', {rotate: 45, transformOrigin: '50% 50%', y: 4, duration: 0.2}, "start");
tl.to('#menu-button_svg__menu-button-line2', {rotate: -45, transformOrigin: '50% 50%', y: -4, duration: 0.2}, "start");
tl.to('.menu-container', {scaleX: 1, transformOrigin: '100% 50%', duration: 0.2}, "start");
tl.from('.wp-block-deltablocks-site-menu .wp-block-navigation-item', {scaleY: 0, y: 100, opacity: 0, duration: 0.2, stagger: 0.1}, "start+=0.1");
tl.from('.wp-block-deltablocks-site-menu .wp-block-deltablocks-social-links', {scale: 0, opacity: 0, duration: 0.2}, "start+=0.5");
// End of menu timeline

// Menu trigger
const trigger = document.getElementById('menu-trigger');
const block = document.querySelector('.wp-block-deltablocks-site-menu');
const menuItems = document.querySelectorAll('.wp-block-deltablocks-site-menu .wp-block-navigation-item');
const preloader = document.getElementById('preloader');
menuItems.forEach((item)=> {
	if (item.classList.contains('current-menu-item')) {
		item.addEventListener('click', (e)=>{
		e.preventDefault();
	});
	} else {
		item.addEventListener('click', ()=>{
			block.classList.remove('menu-openned');
			tl.reverse();
			preloader.classList.add('in');
		});
		item.setAttribute('data-content', item.textContent);
	}
})

trigger.addEventListener('click', () => {
	console.log("menu triggered");
	if (menuOpened === false) {
		block.classList.add('menu-openned');
		tl.play();
		menuOpened = true;
	} else {
		block.classList.remove('menu-openned');
		tl.reverse();
		menuOpened = false;
	}
})
